import { Component } from '@angular/core';
import { TranslatePipe } from '@next/core-lib/i18n';

@Component({
    selector: 'app-spray-legend',
    styleUrl: './spray-legend.component.scss',
    template: `
    <div class="legend">
      <div class="legend-icon-container">
        <img class="legend-icon spray" src="assets/icons/sprays_or_irrigation.svg" alt="" />
      </div>
      <span class="legend-label">{{ 'shared.diseaseTable.sort.spray' | translate }}</span>
    </div>
  `,
    imports: [TranslatePipe],
})
export class SprayLegendComponent { }
